var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBasiliskLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 42,
    viewBox: "0 0 153 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2064 0.20166C25.3021 0.201424 29.3059 1.42106 32.7114 3.70633C36.117 5.9916 38.7713 9.23987 40.3388 13.0403C41.9062 16.8408 42.3164 21.0228 41.5174 25.0574C40.7185 29.092 38.7462 32.798 35.8501 35.7068C32.954 38.6156 29.2642 40.5965 25.2472 41.399C21.2302 42.2015 17.0665 41.7895 13.2826 40.2151C9.49874 38.6408 6.26466 35.9748 3.98937 32.5544C1.71408 29.1339 0.499765 25.1126 0.5 20.9989C0.5 18.2678 1.03559 15.5634 2.07619 13.0401C3.11678 10.5169 4.642 8.22424 6.56478 6.29303C8.48755 4.36183 10.7702 2.82992 13.2824 1.78476C15.7947 0.739597 18.4872 0.20166 21.2064 0.20166V0.20166ZM14.4508 20.9989C14.4508 31.0499 21.2064 39.1973 21.2064 39.1973C21.2064 39.1973 27.9621 31.0499 27.9621 20.9989C27.9621 10.948 21.2064 2.80176 21.2064 2.80176C21.2064 2.80176 14.4508 10.9492 14.4508 20.9989V20.9989Z",
    fill: "#4FFFB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8696 23.3115V7.13477H67.3729V9.44623H69.6743V14.0668H67.3729V16.3783H69.6743V21H67.3729V23.3115H55.8696ZM60.4688 14.0668H65.0703V9.44623H60.4688V14.0668ZM65.0703 16.3783H60.4688V21H65.0703V16.3783Z",
    fill: "#4FFFB0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2758 20.9998H71.9756V14.0666H74.2758V11.7563H85.7791V23.3113H74.2758V20.9998ZM76.576 20.9998H81.1788V14.0666H76.576V20.9998Z",
    fill: "#4FFFB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.884 23.3113H88.0793V20.9998H97.2813V18.6896H88.0781V11.7563H101.883V14.0666H92.6797V16.3781H101.883L101.884 23.3113Z",
    fill: "#4FFFB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.184 9.44623V7.13477H108.786V9.44623H104.184ZM104.184 23.3115V11.7565H108.786V23.3115H104.184Z",
    fill: "#4FFFB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.687 23.3115H111.087V7.13477H115.687V23.3115Z",
    fill: "#4FFFB0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.989 9.44623V7.13477H122.59V9.44623H117.989ZM117.989 23.3115V11.7565H122.59V23.3115H117.989Z",
    fill: "#4FFFB0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.695 23.3113H124.891V20.9998H134.094V18.6896H124.891V11.7563H138.695V14.0666H129.492V16.3781H138.695V23.3113Z",
    fill: "#4FFFB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.2 21H152.5V23.3115H147.898V21H145.598V23.3115H140.997V7.13477H145.598V14.0668H147.898V11.7565H152.5V14.0668H150.2V16.3783H147.898V18.6897H150.2V21Z",
    fill: "#4FFFB0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7758 29.665H63.0504V31.398H64.7758V29.665Z",
    fill: "#4FFFB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5013 29.665H64.7758V31.398H66.5013V29.665Z",
    fill: "#4FFFB0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2279 29.665H66.5024V31.398H68.2279V29.665Z",
    fill: "#4FFFB0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5013 31.3979H64.7758V33.131H66.5013V31.3979Z",
    fill: "#4FFFB0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2279 31.3979H66.5024V33.131H68.2279V31.3979Z",
    fill: "#4FFFB0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9533 31.3979H68.2279V33.131H69.9533V31.3979Z",
    fill: "#4FFFB0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8741 29.665H56.1486V31.398H57.8741V29.665Z",
    fill: "#4FFFB0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5995 29.665H57.8741V31.398H59.5995V29.665Z",
    fill: "#4FFFB0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3249 29.665H59.5995V31.398H61.3249V29.665Z",
    fill: "#4FFFB0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5995 31.3979H57.8741V33.131H59.5995V31.3979Z",
    fill: "#4FFFB0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3249 31.3979H59.5995V33.131H61.3249V31.3979Z",
    fill: "#4FFFB0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0504 31.3979H61.325V33.131H63.0504V31.3979Z",
    fill: "#4FFFB0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6788 29.665H69.9533V31.398H71.6788V29.665Z",
    fill: "#4FFFB0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4042 29.665H71.6788V31.398H73.4042V29.665Z",
    fill: "#4FFFB0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1296 29.665H73.4042V31.398H75.1296V29.665Z",
    fill: "#4FFFB0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4042 31.3979H71.6788V33.131H73.4042V31.3979Z",
    fill: "#4FFFB0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1296 31.3979H73.4042V33.131H75.1296V31.3979Z",
    fill: "#4FFFB0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8551 31.3979H75.1296V33.131H76.8551V31.3979Z",
    fill: "#4FFFB0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5805 29.665H76.855V31.398H78.5805V29.665Z",
    fill: "#4FFFB0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3059 29.665H78.5805V31.398H80.3059V29.665Z",
    fill: "#4FFFB0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0314 29.665H80.3059V31.398H82.0314V29.665Z",
    fill: "#4FFFB0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3059 31.3979H78.5805V33.131H80.3059V31.3979Z",
    fill: "#4FFFB0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0314 31.3979H80.3059V33.131H82.0314V31.3979Z",
    fill: "#4FFFB0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7568 31.3979H82.0314V33.131H83.7568V31.3979Z",
    fill: "#4FFFB0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4835 29.665H83.758V31.398H85.4835V29.665Z",
    fill: "#4FFFB0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2089 29.665H85.4835V31.398H87.2089V29.665Z",
    fill: "#4FFFB0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9343 29.665H87.2089V31.398H88.9343V29.665Z",
    fill: "#4FFFB0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2089 31.3979H85.4835V33.131H87.2089V31.3979Z",
    fill: "#4FFFB0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9343 31.3979H87.2089V33.131H88.9343V31.3979Z",
    fill: "#4FFFB0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6597 31.3979H88.9343V33.131H90.6597V31.3979Z",
    fill: "#4FFFB0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3852 29.665H90.6597V31.398H92.3852V29.665Z",
    fill: "#4FFFB0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1106 29.665H92.3852V31.398H94.1106V29.665Z",
    fill: "#4FFFB0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8361 29.665H94.1106V31.398H95.8361V29.665Z",
    fill: "#4FFFB0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1106 31.3979H92.3852V33.131H94.1106V31.3979Z",
    fill: "#4FFFB0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8361 31.3979H94.1106V33.131H95.8361V31.3979Z",
    fill: "#4FFFB0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5615 31.3979H95.8361V33.131H97.5615V31.3979Z",
    fill: "#4FFFB0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2869 29.665H97.5615V31.398H99.2869V29.665Z",
    fill: "#4FFFB0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M101.012 29.665H99.2869V31.398H101.012V29.665Z",
    fill: "#4FFFB0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M102.739 29.665H101.014V31.398H102.739V29.665Z",
    fill: "#4FFFB0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M101.012 31.3979H99.2869V33.131H101.012V31.3979Z",
    fill: "#4FFFB0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M102.739 31.3979H101.014V33.131H102.739V31.3979Z",
    fill: "#4FFFB0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M104.464 31.3979H102.739V33.131H104.464V31.3979Z",
    fill: "#4FFFB0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M106.19 29.665H104.464V31.398H106.19V29.665Z",
    fill: "#4FFFB0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M107.915 29.665H106.19V31.398H107.915V29.665Z",
    fill: "#4FFFB0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M109.641 29.665H107.915V31.398H109.641V29.665Z",
    fill: "#4FFFB0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M107.915 31.3979H106.19V33.131H107.915V31.3979Z",
    fill: "#4FFFB0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M109.641 31.3979H107.915V33.131H109.641V31.3979Z",
    fill: "#4FFFB0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M111.366 31.3979H109.641V33.131H111.366V31.3979Z",
    fill: "#4FFFB0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M113.092 29.665H111.366V31.398H113.092V29.665Z",
    fill: "#4FFFB0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M114.817 29.665H113.092V31.398H114.817V29.665Z",
    fill: "#4FFFB0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M116.543 29.665H114.817V31.398H116.543V29.665Z",
    fill: "#4FFFB0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M114.817 31.3979H113.092V33.131H114.817V31.3979Z",
    fill: "#4FFFB0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M116.543 31.3979H114.817V33.131H116.543V31.3979Z",
    fill: "#4FFFB0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M118.268 31.3979H116.543V33.131H118.268V31.3979Z",
    fill: "#4FFFB0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M119.995 29.665H118.269V31.398H119.995V29.665Z",
    fill: "#4FFFB0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M121.72 29.665H119.995V31.398H121.72V29.665Z",
    fill: "#4FFFB0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M123.445 29.665H121.72V31.398H123.445V29.665Z",
    fill: "#4FFFB0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M121.72 31.3979H119.995V33.131H121.72V31.3979Z",
    fill: "#4FFFB0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M123.445 31.3979H121.72V33.131H123.445V31.3979Z",
    fill: "#4FFFB0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M125.171 31.3979H123.445V33.131H125.171V31.3979Z",
    fill: "#4FFFB0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M126.896 29.665H125.171V31.398H126.896V29.665Z",
    fill: "#4FFFB0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M128.622 29.665H126.896V31.398H128.622V29.665Z",
    fill: "#4FFFB0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M132.073 29.665H130.347V31.398H132.073V29.665Z",
    fill: "#4FFFB0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M130.347 27.9321H128.622V29.6651H130.347V27.9321Z",
    fill: "#4FFFB0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M128.622 31.3979H126.896V33.131H128.622V31.3979Z",
    fill: "#4FFFB0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M130.347 31.3979H128.622V33.131H130.347V31.3979Z",
    fill: "#4FFFB0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M132.073 31.3979H130.347V33.131H132.073V31.3979Z",
    fill: "#4FFFB0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M133.798 29.665H132.073V31.398H133.798V29.665Z",
    fill: "#4FFFB0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M133.798 31.3979H132.073V33.131H133.798V31.3979Z",
    fill: "#4FFFB0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M144.152 27.9321H142.426V29.6651H144.152V27.9321Z",
    fill: "#4FFFB0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M142.426 31.3979H140.701V33.131H142.426V31.3979Z",
    fill: "#4FFFB0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M140.701 29.6649V31.3979H142.426V29.6649H140.701Z",
    fill: "#4FFFB0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M144.153 27.932V29.665H145.878V27.932H144.153Z",
    fill: "#4FFFB0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M145.877 31.397H147.603V29.664H145.877V31.397Z",
    fill: "#4FFFB0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M147.603 33.1315V31.3984H145.877V33.1315H147.603Z",
    fill: "#4FFFB0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M145.877 34.8644V33.1313H144.152V34.8644H145.877Z",
    fill: "#4FFFB0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M144.152 34.8644V33.1313H142.426V34.8644H144.152Z",
    fill: "#4FFFB0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasiliskLogoFull);
export default __webpack_public_path__ + "static/media/BasiliskLogoFull.088bb7fda2216eaaf9e46d2328c5f675.svg";
export { ForwardRef as ReactComponent };